import React, { Component } from "react";
// import axios from "axios"
import axios from "axios";
import { GrWorkshop } from "react-icons/gr";
import { PiCertificate } from "react-icons/pi";
import { FaRegChartBar } from "react-icons/fa";
import { Link } from "react-router-dom";
import Read from "../../image/reading.jpeg"
// import HeaderDashboard from "../../part/header.dashaboard";
import TutorDashMenu from "../../part/tutor_dash_menu";
import FooterDashboard from "../../part/footer.dashboard";
import AddCourseUploader from "../../part/addcourseupload";
import DashScrollTutorCourse from "../../part/dash.tutor.course.scroll";
import Policy from "../../part/policy";
import DashSearchHeader from "../../part/header.search.dashboard";





class TutorDashboard extends Component {
  state = {
    menuCoverWidth: this.getInitialMenuCoverWidth(),
    topic: [
      { id: "1", head: "Beginners to Intermediate GIS Class", cost: "#140,000", course: "GIS", icon: <GrWorkshop />, type:"Online pre-recorded" },
      { id: "2", head: "Drone Pilot for Beginners", cost: "#300,000", course: "Drone", icon: <PiCertificate />, type:"Online live" },
      { id: "3", head: "Beginners to Advanced GIS Class", cost: "#450,000", course: "GIS", icon: <FaRegChartBar />, type:"Group physical" },
      { id: "4", head: "Drone Pilot for Beginners to Professional", cost: "#450,000", course: "Drone", icon: <GrWorkshop />, type:"Private physical" },
      { id: "5", head: "GIS and Remote Sensing for Agriculture", cost: "#550,000", course: "GIS", icon: <PiCertificate />, type:"Online pre-recorded" },
      { id: "6", head: "Remote Sensing and Google Earth Engine (Level 1)", cost: "#150,000", course: "Remote Sensing", icon: <FaRegChartBar />, type:"Online live"  },
      { id: "7", head: "Digital Soil Mapping", cost: "#400,000", course: "GIS", icon: <GrWorkshop />, type:"Group physical" },
      { id: "8", head: "Remote Sensing and Google Earth Engine - (Level 2)", cost: "#200,000", course: "Remote Sensing", icon: <PiCertificate />,type:"Private physical" },
      { id: "9", head: "GIS and Remote Sensing for Agriculture ", cost: "#550,000", course: "GIS", icon: <FaRegChartBar />, type:"Online pre-recorded" },
      { id: "10", head: "AutoCAD For Surveying and Mapping", cost: "#300,000", course: "Survey", icon: <GrWorkshop />, type:"Online live"  },
      { id: "12", head: "GIS and Remote Sensing for Maritime", cost: "#550,000", course: "GIS", icon: <PiCertificate />, type:"Group physical" },
      { id: "13", head: "Differential GPS (DGPS) Land Surveying Training ", cost: "#450,000", course: "Survey", icon: <FaRegChartBar />,type:"Private physical"  },
      { id: "14", head: "GIS with Python in ArcGIS Beginners - Intermediate", cost: "#120,000", course: "GIS", icon: <GrWorkshop />, type:"Online pre-recorded" },
      { id: "15", head: "WORKSHOP AND SEMINAR", cost: "Free", course: "All", icon: <PiCertificate />, type:"Online live"  },
      { id: "16", head: "Online Scripting in ArcGIS - Advanced", cost: "#140,000", course: "GIS", icon: <FaRegChartBar />, type:"Group physical" },
      { id: "17", head: "Spatial Analysis using ArcGIS", cost: "#150,000", course: "GIS", icon: <FaRegChartBar />,type:"Private physical"  },
      { id: "18", head: "Managing Geospatial Data in ArcGIS", cost: "#150,000", course: "GIS", icon: <GrWorkshop />, type:"Online pre-recorded" },
      { id: "19", head: "Image analysis with ArcGIS", cost: "#150,000", course: "GIS", icon: <PiCertificate />, type:"Online live" },
      { id: "20", head: "GIS Field data collection and management", cost: "#150,000", course: "GIS", icon: <FaRegChartBar />, type:"Group physical"  },

    ],
    windowHeight: window.innerHeight - 60,
    isActive: false,
    courses: [],
    user: {
      name: '',
      email: '',
      role: ''
    },
    isContactVisible: false,

  }
  getInitialMenuCoverWidth() {
    const windowWidth = window.innerWidth;
    if (windowWidth < 900) {
      return 0;
    } else if (windowWidth >= 900 && windowWidth < 1200) {
      return 60;
    } else {
      return 260;
    }
  }

  

  handleOutsideClick = (event) => {
    if (this.node && !this.node.contains(event.target)) {
      this.setState({ isActive: false, });
      const formdisplay = document.querySelector(".dash_add_course_cover")
      formdisplay.style.display = "none"
    }

  };

  handleAddCourses = () => {
    const formcontainer = document.querySelector(".dash_add_course_cover")
    formcontainer.style.display = "flex"
  }


  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('mousedown', this.handleOutsideClick);
    this.fetchCourses();


    const storedUser = localStorage.getItem('user');

if (storedUser) {
  try {
    const user = JSON.parse(storedUser);

    if (user && user.role === 'student') {
      window.location.href = '/dashboard';
    } else {
     this.setState({user:user})
    }

  } catch (error) {
    console.error("Error parsing user data:", error);
    localStorage.removeItem('user');
    window.location.href = '/login'; // Redirect to login on error
  }
}
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }
  fetchCourses = async () => {
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await axios.get("https://api.geoinfoacademy.com/api/tutor/courses/", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      this.setState({ courses: response.data });
      console.log("API Response:", response.data);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("user");
        window.location.href = "/"; 
      } else {
        console.error("Error fetching data:", error);
      }
    }
  };



// to delete courses

handleDelete = async (list) => {
  const accessToken = localStorage.getItem("accessToken");
  try {
      const response = await axios.delete(`https://api.geoinfoacademy.com/api/tutor/courses/${list.id}/`, {
          headers: {
              Authorization: `Bearer ${accessToken}`,
          },
      });

      if (response.status === 204 || response.status === 200) { // Check for successful delete status codes (204 No Content is common)
          console.log("Document deleted successfully:", list.id);
          // Optionally: Refresh the document list after successful deletion
           // Or whatever method you use to refresh the list
          // You might also want to provide user feedback (e.g., a toast notification)
          // alert("Document deleted successfully")
          this.fetchCourses();
      } else {
          console.error("Error deleting document:", response.status, response.data);
          // Handle error (e.g., display an error message to the user)
          alert("Error deleting document")

      }
  } catch (error) {
      console.error("Error deleting document:", error);
      // Handle network errors or other exceptions
      alert("Error deleting document")
  }
};



// it ends here 

  handleResize = () => {
    const menuCover = document.querySelector('.dashboard .menu_cover');
    if (menuCover) {
      this.setState({ menuCoverWidth: menuCover.offsetWidth });
    }
    this.setState({ windowHeight: window.innerHeight - 60 });
  };


  pre_RecorderedfilterData = () => {
    const {courses} = this.state;
    return courses.filter((item) => item.training_type === "Online Prerecorded");
  };
  livefilterData = () => {
    const { courses } = this.state;
    return courses.filter((item) => item.training_type === "Online Live with Facilitator");
  };
  groupfilterData = () => {
    const { courses } = this.state;
    return courses.filter((item) => item.training_type === "General Physical Class");
  };
  privatefilterData = () => {
    const { courses } = this.state;
    return courses.filter((item) => item.training_type === "Physical Private Class");
  };
  render() {
    // const {translatedText } = this.state;
    const { menuCoverWidth, user } = this.state;
    const predata = this.pre_RecorderedfilterData()
    const livedata = this.livefilterData()
    const groupdata = this.groupfilterData()
    const privatedata = this.privatefilterData()
   console.log(this.state)
    return (
      <div className="dashboard">
        <DashSearchHeader onResize={this.handleResize} />
        <TutorDashMenu />
        <div className="dash_body tutor" style={{ width: `calc(100% - ${menuCoverWidth}px - 8px)` }} >
          <div className="dash_home_body">
            <div className="dash_home_body_content">
              <h2><span>{user.name},</span> Create and update Geoinfotech Academy courses for better user experince </h2>
              {/* <Link to="/tutor_course_edit"> */}
              <button className="first" onClick={this.handleAddCourses}>Add Courses</button>
              {/* </Link> */}
              <Link to="/tutor_courses"><button>View Courses</button></Link>
            </div>
            <div className="dash_home_body_img">
              <img src={Read} alt="study" />
            </div>
          </div>
          <div className="dash-main-scroll-cover">
          <DashScrollTutorCourse topics={predata} onDelete = {this.handleDelete}/>
          <DashScrollTutorCourse topics={livedata} onDelete = {this.handleDelete}/>
          <DashScrollTutorCourse topics={groupdata} onDelete = {this.handleDelete}/>
          <DashScrollTutorCourse topics={privatedata} onDelete = {this.handleDelete}/>
          </div>
           {/* <div className="test"></div> */}
           <FooterDashboard />
          <AddCourseUploader onCourseAdded={this.fetchCourses} />
          <Policy/>
        </div>

      </div>
    )
  }
}
export default TutorDashboard